var extractServerAction = function extractServerAction(data) {
  var actions = data === null || data === void 0 ? void 0 : data['atlassian:serverAction'];
  if (!actions) {
    return [];
  }
  if (actions && !Array.isArray(actions)) {
    return [actions];
  }
  return actions;
};
export default extractServerAction;